import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UwAssignmentReshuffleService } from '../uw-assignment-reshuffle/uw-assignment-reshuffle.service';
import { Reshuffle, PipelineLoanDto } from './reshuffle';
import { MatDialog, MatOption } from '@angular/material';
import { UwReshuffleDialogComponent } from '../uw-reshuffle-dialog/uw-reshuffle-dialog.component';
import { TryCatchStmt } from '@angular/compiler';

@Component({
    selector: 'app-uw-assignment-reshuffle',
    templateUrl: './uw-assignment-reshuffle.component.html',
    styleUrls: ['./uw-assignment-reshuffle.component.css']
})

//OBSOLETE - DO NOT REENABLE
export class UwAssignmentReshuffleComponent implements OnInit {

    @ViewChild('allSelected') private allSelected: MatOption;
    public uwReshuffleForm: FormGroup;
    public loanChannels: string[] = [];
    public loanPurposes: string[] = [];
    public underwriters = [];
    public underwriterPersonas: string[] = ["Underwriter", "Fast Track UW", "UW 1", "Quick Approval UW"];
    public searchValue: string = null;
    public allUnderwriter = [];
    public selectedUW = [];
    public loanNumbers: string[];
    public loans: PipelineLoanDto[];
    public assignedDate: Date;
    public showUserSelection = false;
    public unAssignedloans: string[] = [];
    public unAssignedSsnloans: string[] = [];
    public isLoansAvailable = false;
    public selectedLoans: string[] = [];
    public isLoading: boolean = false;
    public inputMessage: string = "";
    public successErrorMessgae: string = "";

    constructor(private dialog: MatDialog, private fb: FormBuilder,
        private service: UwAssignmentReshuffleService) { }

    ngOnInit() {

        this.getLoanChannels();
        this.getLoanPurposes();
        this.getUnderwriters(0);
        this.uwReshuffleForm = this.fb.group({
            getLoan: this.fb.group({
                uwAssignmentDate: [null, Validators.required],
                loanChannel: [null, Validators.required],
                loanPurpose: [null, Validators.required]
            }),
            loans: [null],
            uwSelection: [null]
        });
    }

    async getLoanChannels() {
        this.service.getLoanChannels().then(data => {
            this.loanChannels = data.map(i => { return i.name });
        });
    }

    async getLoanPurposes() {
        this.service.getLoanPurposes().then(data => {
            this.loanPurposes = data.map(i => { return i.name });
        });
    }

    async getUnderwriters(index) {
        var persona = this.underwriterPersonas[index];
        this.service.getUnderwriters(persona).then(data => {
            data.forEach(res => {
                this.underwriters.push(res);
                this.allUnderwriter.push(res);
            });
            this.underwriters.sort((a, b) => (a.firstName + ' ' + a.lastName).localeCompare(b.firstName + ' ' + b.lastName));
            this.allUnderwriter.sort((a, b) => (a.firstName + ' ' + a.lastName).localeCompare(b.firstName + ' ' + b.lastName));

            index++;

            if (index < this.underwriterPersonas.length) {
                this.getUnderwriters(index);
            }
        });
    }

    async getLoansToReshuffle() {
        this.assignedDate = new Date(this.uwReshuffleForm.value.getLoan.uwAssignmentDate.getFullYear(),
            this.uwReshuffleForm.value.getLoan.uwAssignmentDate.getMonth(),
            this.uwReshuffleForm.value.getLoan.uwAssignmentDate.getDate());

        this.isLoading = true;
        this.inputMessage = "Fetching loans, please wait...";
        this.successErrorMessgae = "";

        this.service.getLoanstoReshuffle("Underwriter", this.assignedDate.toDateString(), this.uwReshuffleForm.value.getLoan.loanChannel, this.uwReshuffleForm.value.getLoan.loanPurpose).then(loans => {
            this.isLoading = false;
            this.inputMessage = "";
            if (loans != null && loans.length > 0) {
                this.loans = loans;
                this.showUserSelection = true;
                this.uwReshuffleForm.controls["uwSelection"].setErrors(null);
                this.uwReshuffleForm.controls["loans"].setErrors(null);
            } else {
                this.loans = [];
                this.showUserSelection = false;
                var message = "Loans are not available for the specified  selection criteria, modify selection criteria to fetch loans."
                var dialogData = [{ "message": message, "LoanList": null }];

                this.dialog.open(UwReshuffleDialogComponent, {
                    width: "400px", height: "auto",
                    data: dialogData,
                });
            }

        }).catch(error => {
            console.log(error);
            this.isLoading = false;
        });
    }

    async confirmReshuffle() {
        this.inputMessage = "";
        this.isLoading = true;
        this.service.confirmReshuffle(this.selectedLoans).then(() => {
            let reshuffleDtos: Reshuffle[] = new Array<Reshuffle>();

            this.selectedLoans.forEach((loanNumber) => {
                var reshuffleDto: Reshuffle = new Reshuffle();
                reshuffleDto.Users = [];
                this.selectedUW.forEach((Uw) => {
                    reshuffleDto.Users.push(Uw);
                });
                reshuffleDto.Loan = new PipelineLoanDto();
                var loan: any = this.loans.filter(function (e) {
                    return e.fields["Fields.364"] == loanNumber;
                });
                reshuffleDto.Loan.LoanGuid = loan[0].loanGuid;
                reshuffleDto.Loan.fields = loan[0].fields;

                reshuffleDtos.push(reshuffleDto);
            });

            this.reshuffleLoan(reshuffleDtos, 0);

        }).catch(error => {
            console.log(error);
            this.isLoading = false;
        });
    }

    reshuffleLoan = (reshuffleDtos: Reshuffle[], index: number): boolean => {
        this.inputMessage = (index + 1) + " out of " + this.selectedLoans.length + " loans are processing...";
        this.successErrorMessgae = "";
        this.service.makeUnderwriterLoansReshuffleAssignment(reshuffleDtos[index]).then(data => {
            if (!data.assignedSuccessfully) {
                if (data.messages && data.messages.indexOf("SSNMatchFailed") !== -1) {
                    this.unAssignedSsnloans.push(reshuffleDtos[index].Loan.fields["Fields.364"]);
                } else {
                    this.unAssignedloans.push(reshuffleDtos[index].Loan.fields["Fields.364"]);
                }
            }

            index = index + 1;
            if (index < this.selectedLoans.length) {
                reshuffleDtos[index].Users.forEach((u) => {
                    //data.messages[2] returns the the encompass username for which loan assigned.
                    if (data.assignedSuccessfully && u.encompassUserName == data.messages[2]) {
                        u.capacity = u.capacity - 1;
                    }
                });
                this.reshuffleLoan(reshuffleDtos, index);
            } else {
                this.finalizeShuffle();
            }
        }).catch(error => {
            console.log(error);
            this.unAssignedloans.push(reshuffleDtos[index].Loan.fields["Fields.364"]);
            index = index + 1;
            if (index < this.selectedLoans.length) {
                this.reshuffleLoan(reshuffleDtos, index);
            } else {
                this.finalizeShuffle();
            }
        });
        return true;
    }

    finalizeShuffle = async (): Promise<void> => {
        await this.showMessage();
        this.uwReshuffleForm.reset();
        this.selectedUW = [];
        this.selectedLoans = [];
        this.uwReshuffleForm.controls["uwSelection"].setErrors(null);
        this.uwReshuffleForm.controls["loans"].setErrors(null);
        var getLoanFormGroup = this.uwReshuffleForm.controls.getLoan;
        var assignmentDateControl = getLoanFormGroup.get("uwAssignmentDate");
        assignmentDateControl.setErrors(null);
        var loanChannelControl = getLoanFormGroup.get("loanChannel");
        loanChannelControl.setErrors(null);
        this.showUserSelection = false;
        this.isLoading = false;
        this.inputMessage = "";
        this.successErrorMessgae = "";
        this.unAssignedloans = [];
        this.unAssignedSsnloans = [];
    }

    showSelected = (): boolean => {
        return (this.selectedLoans && this.selectedLoans.length > 0) || (this.selectedUW && this.selectedUW.length > 0);
    }

    dateFilter = (d: Date): boolean => {
        let now = new Date()
        let last30days = new Date(now.setDate(now.getDate() - 30));
        let result = d > last30days && d < new Date();
        return result;
    }

    onSelectionChange(event) {
        if (event.value.length > 0) {
            event.value.forEach(val => {
                if (!this.selectedUW.includes(val)) {
                    var usercapacity = (<HTMLInputElement>document.getElementById(val.id)).value;
                    val.capacity = (usercapacity == "" ? null : usercapacity);
                    this.selectedUW.push(val);
                }
            })
            let tempUsers = [...this.selectedUW];
            tempUsers.forEach((val, index) => {
                if (!event.value.includes(val)) {
                    this.selectedUW.splice(index, 1);
                }
            })
        }
        else {
            this.selectedUW = [];
        }
    }

    onTextChange(event) {
        var usercapacity = (<HTMLInputElement>document.getElementById(event.srcElement.id)).value;
        if (usercapacity == "") {
            (<HTMLInputElement>document.getElementById(event.srcElement.id)).value = "";
            usercapacity = "";
        }

        try {
            if (parseInt(usercapacity) < 1) {
                (<HTMLInputElement>document.getElementById(event.srcElement.id)).value = "";
                usercapacity = "";
            }
        } catch (err) {
            (<HTMLInputElement>document.getElementById(event.srcElement.id)).value = "";
            usercapacity = "";
        }
        this.selectedUW.filter(function (e) {
            if (e.id == event.srcElement.id) {
                e.capacity = usercapacity;
            }
        });
    }


    onSearchChange(event) {
        if (this.searchValue) {
            this.underwriters = this.allUnderwriter.filter(value => value.name.toLowerCase().includes(this.searchValue.toLowerCase()));
            this.selectedUW.forEach(value => {
                if (!this.underwriters.includes(value)) {
                    this.underwriters.push(value)
                }
            });
        }
        else {
            this.underwriters = this.allUnderwriter;
        }
    }

    async getLoans() {
        this.resetForm();

        if (!this.uwReshuffleForm.controls.getLoan.valid) {

            var getLoanFormGroup = this.uwReshuffleForm.controls.getLoan;

            var assignmentDateControl = getLoanFormGroup.get("uwAssignmentDate");
            assignmentDateControl.markAsTouched();
            assignmentDateControl.markAsDirty();
            if (assignmentDateControl.status.toUpperCase() != "VALID") {
                assignmentDateControl.setErrors({ 'required': true });
            }

            var loanChannelControl = getLoanFormGroup.get("loanChannel");
            loanChannelControl.markAsTouched();
            loanChannelControl.markAsDirty();
            if (loanChannelControl.status.toUpperCase() != "VALID") {
                loanChannelControl.setErrors({ 'required': true });
            }
            return;
        }

        else {
            await this.getLoansToReshuffle();
        }
    }

    async reshuffle() {
        if (!this.uwReshuffleForm.valid) {
            return;
        }

        var totalCapacity = 0;
        for (var i = 0; i < this.selectedUW.length; i++) {
            if (this.selectedUW[i].capacity == null || this.selectedUW[i].capacity.trim() === "" || parseInt(this.selectedUW[i].capacity.trim()) <= 0) {
                var data = [{ "message": "Please define valid capacity for all selected underwriters", "LoanList": null }];
                this.dialog.open(UwReshuffleDialogComponent, {
                    width: "400px", height: "400px",
                    data: data,
                });
                return;
            }
            totalCapacity = (totalCapacity) + parseInt(this.selectedUW[i].capacity.trim())
        }

        if (totalCapacity < this.selectedLoans.length) {

            var data = [{ "message": "Total capacity of selected underwriter's must be greater than or equal to the number of selected loans", "LoanList": null }];
            this.dialog.open(UwReshuffleDialogComponent, {
                width: "400px", height: "400px",
                data: data,
            });

            return;
        }

        await this.confirmReshuffle();
    }

    async showMessage() {
        var message: string;
        var assignmentDate: string;
        var data = [];
        assignmentDate = this.uwReshuffleForm.value.getLoan.uwAssignmentDate.getMonth() + 1 + "/" + this.uwReshuffleForm.value.getLoan.uwAssignmentDate.getDate() + "/" + this.uwReshuffleForm.value.getLoan.uwAssignmentDate.getFullYear();

        if (this.unAssignedloans != null && this.unAssignedloans != undefined && this.unAssignedloans.length > 0) {
            message = "Applicable loans with an assignment date of " + assignmentDate + " have been re-assigned as requested with the below exceptions.";
            message += " The listed loans were not re-assigned because amongst the selected underwriters there was not a user with the necessary capacity and skillset.";

            await this.service.ResetLoansBacktoActive(this.unAssignedloans, this.assignedDate);

        }
        if (this.unAssignedSsnloans != null && this.unAssignedSsnloans != undefined && this.unAssignedSsnloans.length > 0) {
            message = "Applicable loans with an assignment date of " + assignmentDate + " have been re-assigned as requested with the below exceptions.";
            message += " The listed loans were not re-assigned because amongst the selected underwriters there was not a user with the necessary capacity and skillset.";

            await this.service.ResetLoansBacktoActive(this.unAssignedSsnloans, this.assignedDate);
        }
        if (this.unAssignedloans.length == 0 && this.unAssignedSsnloans.length == 0) {
            message = "All applicable loans with an assignment date of " + assignmentDate + " have been re-assigned as requested.";
            this.unAssignedloans = [];
            this.unAssignedSsnloans = [];
        }

        data = [{ "message": message, "LoanList": this.unAssignedloans, "loanlistSsnMismatch": this.unAssignedSsnloans }];

        this.dialog.open(UwReshuffleDialogComponent, {
            width: "400px", height: "auto",
            data: data,
        });
    }

    togglePerLoan() {
        if (this.allSelected.selected) {
            this.selectedLoans = this.uwReshuffleForm.controls.loans.value;
            this.allSelected.deselect();

            if (this.uwReshuffleForm.controls.loans.value[0] === 0) {
                this.uwReshuffleForm.controls.loans.patchValue([]);
                this.selectedLoans = [];
            }

            return false;
        } else {
            this.selectedLoans = this.uwReshuffleForm.controls.loans.value;
        }
        if (this.uwReshuffleForm.controls.loans.value.length == this.loans.length) {
            this.allSelected.select();
        }


    }

    toggleAllSelection() {
        if (this.allSelected.selected) {
            this.selectedLoans = [];
            this.uwReshuffleForm.controls.loans
                .patchValue([...this.loans.map(item => item.fields["Fields.364"]), 0]);

            this.loans.forEach((x) => {
                this.selectedLoans.push(x.fields["Fields.364"]);
            });
        } else {
            this.uwReshuffleForm.controls.loans.patchValue([]);
            this.selectedLoans = [];
        }
    }

    private async resetForm() {
        this.selectedLoans = [];
        this.selectedUW = [];
        this.uwReshuffleForm.controls['loans'].reset();
        this.uwReshuffleForm.controls['uwSelection'].reset();
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/uw-assignment-reshuffle/uw-assignment-reshuffle.component.ts